import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchText } from "../../../store/profileDetail/profileDetail.reducer";
import { selectProfileDetailSearchText } from "../../../store/profileDetail/selector/selectProfileDetailSearchText";


export const UserProfileSearchBar = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(selectProfileDetailSearchText);

  return (
    <IonSearchbar
      debounce={900}
      value={searchText}
      onIonChange={(e) => dispatch(setSearchText(e.detail.value as unknown as string))}
    />
  );
};
